import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header cursor-pointer" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row mb-7" }
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_9 = { class: "d-block fw-bold text-start" }
const _hoisted_10 = { class: "text-dark fw-bolder d-block fs-4 mb-1" }
const _hoisted_11 = { class: "text-dark-gray fw-bolder d-block fs-5 mb-2" }
const _hoisted_12 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "d-flex my-4" }
const _hoisted_15 = { class: "indicator-label" }
const _hoisted_16 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_17 = { class: "indicator-progress" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("buyCourse")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCurses.filter(courseItem => courseItem['isAvailable']), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-lg-6",
            key: item._id
          }, [
            _createVNode(_component_Field, {
              type: "radio",
              class: "btn-check",
              name: "accountType",
              modelValue: _ctx.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event)),
              onChange: ($event: any) => (_ctx.chooseCourse(item._id, item.payment_cost)),
              value: index === 1 ? 'administrator' : 'personal',
              id: item._id
            }, null, 8, ["modelValue", "onChange", "value", "id"]),
            _createElementVNode("label", {
              class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
              for: item._id
            }, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com005.svg" })
              ]),
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.course_name), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(item.payment_cost) + " ₽ ", 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(item.course_description), 1),
                _hoisted_13
              ])
            ], 8, _hoisted_7)
          ]))
        }), 128)),
        _createVNode(_component_ErrorMessage, { name: "accountType" })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-lg btn-primary me-3",
            ref: "submitButton",
            "data-kt-indicator": "off",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buyCourse()))
          }, [
            _createElementVNode("span", _hoisted_15, [
              _createTextVNode(_toDisplayString(_ctx.t("goToPayment")) + " ", 1),
              _createElementVNode("span", _hoisted_16, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
              ])
            ]),
            _createElementVNode("span", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.t("pleaseWait")) + " ", 1),
              _hoisted_18
            ])
          ], 512)
        ])
      ])
    ])
  ]))
}